<template>
  <div class="page" id="text-sources-notes">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      background-color="#EBF9FF"
      color="#02B99E"
    >
    </loading>
    <div class="decorative-texture top">
            <img src="../../assets/img/texture.png" />
        </div>
        <div class="decorative-texture position-bottom movil-only">
            <img src="../../assets/img/texture.png" />
        </div>
    <vue-snotify></vue-snotify>

    <!--<mnavbar @menuVisible="menuVisible"></mnavbar>
    <side-menu :menuOn="menuOn" @menuVisible="menuVisible"></side-menu>-->

    <email-alert
      :show="emailModal"
      :subject="item.titulo"
      @enviar="sendEmail"
      @cancelarEnviar="cancelarEnviar"
      @error="error"
    ></email-alert>
    <section>
      <div class="container-fluid">
        <div class="w80">
          <div class="row">
            <div :class="['col-sm-12', { 'col-md-5': item.media }]">
              <div class="row align-items-center">
                <div class="col-sm-12 center">
                  <div class="inlineBlock">
                    <img
                      :src="item.media"
                      @error="replaceByDefault"
                      class="post-image"
                      v-if="item.media"
                    />
                  </div>
                </div>
              </div>
              <div class="row actions align-items-center" v-if="item.media">
                <div class="col">
                  <div class="button-container">
                    <button
                      :class="[
                        'button',
                        'small',
                        'tooltip',
                        'tooltip-bottom',
                        'accion-video',
                        { active: like },
                      ]"
                      data-tooltip="Positiva"
                      @click="saveLike(1)"
                    >
                      <svg
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 
                                      2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 
                                      2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                        />
                      </svg>
                      <span></span>
                    </button>
                    <button
                      :class="[
                        'button',
                        'small',
                        'tooltip',
                        'tooltip-bottom',
                        'accion-video',
                        'accion-video',
                        { active: dislike },
                      ]"
                      data-tooltip="Negativa"
                      @click="saveLike(0)"
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 
                                  2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 
                                  2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
                        />
                      </svg>
                      <span></span>
                    </button>
                    <button
                      :class="[
                        'button',
                        'small',
                        'tooltip',
                        'tooltip-bottom',
                        'accion-video',
                        { active: meh },
                      ]"
                      @click="saveLike(2)"
                      data-tooltip="Informativa"
                    >
                      <svg
                        fill="currentColor"
                        aria-hidden="true"
                        focusable="false"
                        stroke="currentColor"
                        data-prefix="fas"
                        data-icon="info-circle"
                        class="svg-inline--fa fa-info-circle fa-w-16"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                        ></path>
                      </svg>
                      <span></span>
                    </button>
                  </div>
                  <!-- button-container -->
                </div>
                <!-- col -->
                <div class="col-auto">
                  <div class="calificacion">
                    <div class="stars">
                      <button
                        v-for="i in 4"
                        :key="i"
                        :class="stars[i - 1]"
                        :data-tooltip="getTooltip(i)"
                        @click="saveStars(i)"
                        @mouseover="pintaStars(i)"
                        @mouseleave="rollbackStars()"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
                          />
                        </svg>
                      </button>
                    </div>
                    <!-- stars -->
                  </div>
                  <!-- calificacion -->
                </div>
                <!-- col-auto -->
              </div>
              <!-- row actions align-items-center -->
            </div>
            <div :class="['col-sm-12', { 'col-md-7': item.media }]">
              <div class="row align-items-center">
                <div class="col">
                  <div class="user-avatar">
                    <div
                      class="img-avatar"
                      :style="{
                        'background-image':
                          'url(' +
                          item.sourceImg +
                          '),url(' +
                          defaultImage +
                          ')',
                      }"
                    ></div>
                    <div class="data-avatar">
                      <p
                        class="user-name noticieroName touchpad"
                        @click="goToNotes"
                        @mouseover="setTooltip"
                        @mouseleave="removeTooltip"
                      >
                        {{ item.noticiero_nombre }}
                        <span class="tooltipLabel" v-if="tooltip"
                          >Escaleta</span
                        >
                      </p>
                      <p class="user">
                        <a class="verde" :href="item.link" target="_blank">{{
                          item.sourceUrl ? item.sourceUrl : "ir a la nota"
                        }}</a>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <svg
                    class="svgPD"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    focusable="false"
                    width="30px"
                    height="30px"
                    preserveAspectRatio="xMidYMid meet"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6v12H4V6h16m2-2H2v14s0 2 2 2h16s2 0 2-2V4m-12 9H6V8h4v5m8 0h-7v-2h7v2m0-3h-7V8h7v2z"
                    />
                  </svg>
                </div>
                <!--<div class="col-auto">
                  <button
                    class="button back-button tooltip"
                    data-tooltip="Regresar"
                    @click="goBack"
                  >
                    <svg
                      width="10.975"
                      height="9.998"
                      viewBox="0 0 10.975 9.998"
                    >
                      <path
                        id="Color_Overlay"
                        data-name="Color Overlay"
                        d="M26.825,57.835l-3.549-4.046A.634.634,0,0,1,23,53.244v-.366a.7.7,0,0,1,.068-.308.641.641,0,0,1,.14-.282l3.615-4.122a.439.439,0,0,1,.706.028l.205.267a.706.706,0,0,1-.023.861L25.13,52.268h8.343a.564.564,0,0,1,.5.609v.366a.564.564,0,0,1-.5.609H25.236l2.478,2.825a.708.708,0,0,1,.023.861l-.205.266a.462.462,0,0,1-.365.194A.455.455,0,0,1,26.825,57.835Z"
                        transform="translate(-23 -48.001)"
                      />
                    </svg>
                  </button>
                </div>-->
              </div>
              <!-- row align-items-center -->
              <div class="post-info">
                <div class="info-heading">
                  <div class="row align-items-center">
                    <div class="col">
                      <div class="input-field" v-if="editMode">
                        <br />
                        <input
                          type="text"
                          placeholder="Titulo de la nota"
                          v-model="item.titulo"
                        />
                        <br />
                      </div>
                      <h2 class="tiulo-post noMarginBottom" v-else>
                        {{ item.titulo }}
                      </h2>
                      <p v-if="item.grupo" class="blanco">
                        Grupo periodistico: {{item.grupo}}
                      </p>
                      <p class="blanco">
                        Fecha: {{ getFechaSeparada(item.publicado_utc).fecha }}
                        <br /><br />
                        Hora : {{ getFechaSeparada(item.publicado_utc).hora }}
                        <br /><br />
                      </p>
                      <p v-if="item.region" class="blanco">
                        Región: {{item.region}}
                      </p>
                    </div>
                    <!-- col -->
                  </div>
                  <!-- row align-items-center -->
                </div>
                <!--info-heading-->
                <div class="content">
                  <div class="input-field description" v-if="editMode">
                    <ckeditor
                      :editor="editor"
                      v-model="item.descripcion"
                      :config="editorConfig"
                    ></ckeditor>
                    <br />
                  </div>
                  <p
                    :key="contentKey"
                    class="justificado"
                    v-html="item.descripcion"
                    v-else
                  ></p>
                  <textarea
                    class="escondido"
                    ref="copyText"
                    v-model="getContent"
                  ></textarea>
                </div>
                <!-- content -->
              </div>
              <!--post-info-->
              <div class="row actions align-items-center">
                <div class="col" v-if="!item.media">
                  <div class="button-container">
                    <button
                      :class="[
                        'button',
                        'small',
                        'tooltip',
                        'tooltip-bottom',
                        'accion-video',
                        { active: like },
                      ]"
                      data-tooltip="Positiva"
                      @click="saveLike(1)"
                    >
                      <svg
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 
                                      2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 
                                      2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                        />
                      </svg>
                      <span></span>
                    </button>
                    <button
                      :class="[
                        'button',
                        'small',
                        'tooltip',
                        'tooltip-bottom',
                        'accion-video',
                        { active: dislike },
                      ]"
                      data-tooltip="Negativa"
                      @click="saveLike(0)"
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 
                                  2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 
                                  2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
                        />
                      </svg>
                      <span></span>
                    </button>
                    <button
                      :class="[
                        'button',
                        'small',
                        'tooltip',
                        'tooltip-bottom',
                        'accion-video',
                        { active: meh },
                      ]"
                      data-tooltip="Informativa"
                      @click="saveLike(2)"
                    >
                      <svg
                        fill="currentColor"
                        aria-hidden="true"
                        focusable="false"
                        stroke="currentColor"
                        data-prefix="fas"
                        data-icon="info-circle"
                        class="svg-inline--fa fa-info-circle fa-w-16"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                        ></path>
                      </svg>
                      <span></span>
                    </button>
                  </div>
                  <!-- button-container -->
                </div>
                <!-- col -->
                <div
                  :class="[{ col: !item.media }, { 'col-auto': item.media }]"
                  v-if="!item.media"
                >
                  <div class="calificacion">
                    <div class="stars">
                      <button
                        v-for="i in 4"
                        :key="i"
                        :data-tooltip="getTooltip(i)"
                        :class="stars[i - 1]"
                        @click="saveStars(i)"
                        @mouseover="pintaStars(i)"
                        @mouseleave="rollbackStars()"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
                          />
                        </svg>
                      </button>
                    </div>
                    <!-- stars -->
                  </div>
                  <!-- calificacion -->
                </div>
                <!-- col-auto -->
                <div
                  :class="[{ col: item.media }, { 'col-auto': !item.media }]"
                >
                  <div class="button-container derecha">
                    <button
                      class="button small accion-video tooltip tooltip-top blanco"
                      data-tooltip="Guardar Edición"
                      @click="saveEdit()"
                      v-if="editMode"
                    >
                      <font-awesome-icon
                        icon="check"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>
                    <button
                      class="button small accion-video tooltip tooltip-top blanco"
                      data-tooltip="Cancelar Edición"
                      @click="cancelEdit()"
                      v-if="editMode"
                    >
                      <font-awesome-icon
                        icon="times"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>

                    <button
                      class="button small star-video tooltip tooltip-top blanco"
                      data-tooltip="Reestablecer Nota"
                      @click="redo"
                      v-if="editMode == false && item.metadatos"
                    >
                      <font-awesome-icon
                        icon="redo-alt"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>

                    <button
                      class="button small star-video tooltip tooltip-top blanco"
                      data-tooltip="Copiar Nota"
                      @click="copy"
                      v-if="editMode == false"
                    >
                      <font-awesome-icon
                        icon="copy"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>
                    <button
                      class="button small accion-video tooltip tooltip-top blanco"
                      data-tooltip="Editar"
                      @click="editNote()"
                      v-if="editMode == false"
                    >
                      <font-awesome-icon
                        icon="edit"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>
                    <button
                      class="button small accion-video tooltip tooltip-top blanco"
                      data-tooltip="Agregar a carpeta"
                      @click="saveNote"
                      v-if="editMode == false"
                    >
                      <font-awesome-icon
                        icon="folder-plus"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>
                    <!--<button class="button small accion-video tooltip tooltip-top  blanco " data-tooltip="Enviar"  @click="enviar" v-if="editMode==false">
                        <font-awesome-icon  icon="paper-plane" style="color:#ebf9ff; height:15px"/>
                      </button>-->
                    <button
                      class="button small accion-video tooltip tooltip-top blanco"
                      data-tooltip="Compartir"
                      @click="compartir"
                      v-if="editMode == false"
                    >
                      <font-awesome-icon
                        icon="share-alt"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>
                    <button
                      class="button small accion-video tooltip tooltip-top blanco"
                      data-tooltip="Añadir a newsletter"
                      @click="agregar_note_newsletter"
                      v-if="permissionsNewsletter"
                    >
                      <font-awesome-icon
                        icon="folder-plus"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>

                    <!--<button class="button small accion-video tooltip tooltip-top  " data-tooltip="Añadir Comentario"  @click="showComentario">
                        <font-awesome-icon  icon="comment" style="color:#ebf9ff; height:15px"/>
                      </button>-->
                  </div>
                </div>
              </div>
              <!-- row actions align-items-center -->
            </div>
            <!-- col-sm-12-->
          </div>
          <!-- row -->

          <!--<div class="row align-items-center" v-if="item.media" style="margin-top:2%">
              <div class="col-sm-12  center" >
                <div class="inlineBlock">
                  <img :src="item.media" class="post-image" />
                </div>
              </div>
              
            </div>-->
          <br />
          <div class="keywords center">
            <div
              class="chip iconed"
              v-for="(keyword, index) in item.keywords"
              :key="index"
            >
              {{ keyword }}
            </div>
          </div>
          <div class="divider"></div>
          <div class="comentarios">
            <h2>Comentarios</h2>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="row">
                  <div class="col-12">
                    <label class="form-text">Escriba un comentario</label>
                    <button
                      class="button small accion-video tooltip tooltip-top derecha verde-claro"
                      data-tooltip="Comentar"
                      @click="addComment"
                      v-if="comment.trim() != ''"
                    >
                      <font-awesome-icon
                        icon="check"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>
                    <button
                      class="button small accion-video tooltip tooltip-top derecha verde-claro"
                      data-tooltip="Borrar"
                      @click="cleanComment"
                      v-if="comment.trim() != ''"
                    >
                      <font-awesome-icon
                        icon="trash-alt"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <ckeditor
                      :editor="editor"
                      v-model="comment"
                      :config="editorConfig"
                    ></ckeditor>
                  </div>
                </div>
              </div>

              <div
                class="col-sm-12 col-md-6"
                style="max-height: 300px; width: 100%; overflow-y: scroll"
                v-if="comments.length > 0"
              >
                <div
                  class="noMargin"
                  style="
                    width: 100%;
                    border-bottom: 1px solid #24404b;
                    padding-bottom: 1%;
                  "
                  v-for="(comment, index) in comments"
                  :key="comment.key"
                >
                  <div
                    class="inlineBlock noPadding noMargin"
                    style="width: 95%"
                  >
                    <div v-html="convertString(comment.comentario)"></div>
                    <label class="sub">{{ getFecha(comment.created) }}</label>
                  </div>

                  <div
                    class="inlineBlock"
                    style="width: 5%; float: right; top: 0"
                  >
                    <button
                      class="button small accion-video tooltip tooltip-bottom derecha verde-claro"
                      data-tooltip="Borrar"
                      @click="eliminaComentario(comment.key, index)"
                    >
                      <font-awesome-icon
                        icon="trash-alt"
                        style="color: #ebf9ff; height: 15px"
                      />
                    </button>
                    <!--<close-icon class="icon_close touchpad derecha" @click="eliminaComentario(comment.key,index)"></close-icon>-->
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6"></div>
              <div class="col-sm-12 col-md-6">
                <div
                  class="button-circle-more secondary"
                  v-if="LastEvaluatedKey"
                >
                  <button class="circle-more" @click="getComments">
                    <svg viewBox="0 0 18 18">
                      <g
                        id="Grupo_29"
                        data-name="Grupo 29"
                        transform="translate(-171 -753)"
                      >
                        <rect
                          id="Rectángulo_redondeado_903"
                          data-name="Rectángulo redondeado 903"
                          width="2"
                          height="18"
                          rx="1"
                          transform="translate(179 753)"
                          fill="#fff"
                        />
                        <rect
                          id="Rectángulo_redondeado_903_copia"
                          data-name="Rectángulo redondeado 903 copia"
                          width="18"
                          height="2"
                          rx="1"
                          transform="translate(171 761)"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                  </button>
                </div>
                <!-- END BUTTON CIRCLE -->
              </div>
            </div>
          </div>
          <!-- comments -->
          <!--<div class="page-actions"> <button class="button small outline" @click="goBack">Regresar</button></div>-->
        </div>
        <!-- div w80-->
      </div>
    </section>
    <confirm-modal
      :smsModal="smsModal"
      :show="showModal"
      @cancelar="hideModal"
      @aceptar="elimina"
    ></confirm-modal>
    <confirm-modal-comment
      :smsModal="smsModal"
      :show="showModal"
      @cancelar="hideModal"
      @aceptar="deleteComment"
    ></confirm-modal-comment>
    <share-box
      :show="shareAlt"
      @share="share"
      @cancelar="cancelarShare"
    ></share-box>
  </div>
</template>

<script>
import SideMenu from "@/components/sideMenu";
import mnavbar from "@/components/mnavbar";
import mvideo from "@/components/mvideo";

import emailAlert from "@/components/emailAlert";
import { strings } from "@/services/strings.js";

import videojs from "video.js";
window.videojs = videojs;
require("videojs-contrib-hls/dist/videojs-contrib-hls");
import confirmModal from "@/components/confirm";
import confirmModalComment from "@/components/confirm";
import shareBox from "@/components/shareBox";

import moment from "moment-timezone";

import closeIcon from "vue-material-design-icons/Close.vue";
import _ from "lodash";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCloudDownloadAlt,
  faPaperPlane,
  faSave,
  faChevronDown,
  faFolderPlus,
  faComment,
  faTimes,
  faEdit,
  faCheck,
  faShareAlt,
  faCopy,
  faRedoAlt,
} from "@fortawesome/free-solid-svg-icons";
library.add(faCloudDownloadAlt);
library.add(faPaperPlane);
library.add(faSave);
library.add(faChevronDown);
library.add(faFolderPlus);
library.add(faComment);
library.add(faTimes);
library.add(faEdit);
library.add(faCheck);
library.add(faShareAlt);
library.add(faCopy);
library.add(faRedoAlt);

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

require("videojs-youtube/dist/Youtube");

import InstagramEmbed from "vue-instagram-embed";

export default {
  components: {
    SideMenu,
    mnavbar,
    mvideo,
    confirmModal,
    closeIcon,
    emailAlert,
    InstagramEmbed,
    confirmModalComment,
    shareBox,
  },
  mixins: [strings],
  data() {
    return {
      isLoading: false,
      menuOn: false,
      fuente_info: null,
      url: this.$store.getters.getMainUrl,
      item: {},
      showModal: false,
      smsModal: "Realmente, ¿Desea eliminar ésta nota de la carpeta?",
      stars: [
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
      ],
      noStars: 0,
      like: false,
      dislike: false,
      meh: false,
      comments: [],
      emailModal: false,
      thumb: "",
      activeVideo: false,
      from: "",
      fromParams: {},
      extraParams: {},
      media: "",
      defaultImage: this.$store.state.defaultNote,
      pageImg: "",
      post_url: "",
      tweet: null,
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        toolbar: {
          items: ["bold", "italic"],
        },
      },
      comment: "",
      showComment: false,
      editMode: false,
      originalItem: {},
      LastEvaluatedKey: null,
      options: {
        //tweet
        align: "center",
        lang: "es",
      },
      commentKey: null,
      commentIndex: -1,
      fbVideo: false,
      tooltip: false,
      //compartir
      shareAlt: false,
      urlShare: "",
      contentKey: new Date().getTime(),
      permissionsNewsletter: false,
    };
  },
  computed: {
    token() {
      return this.$store.getters.getToken;
    },
    getContent() {
      var fecha = this.parseFecha(this.item.publicado_utc);
      var arrFecha = fecha.split(" ");
      var publicado = this.item.publicado ? this.item.publicado.split(" "): arrFecha;
      var hora = this.item.descripcion ? this.item.descripcion.inicio : publicado[1];


      var medio = "";
      var descripcion = this.item.descripcion
        ? this.item.descripcion.replace(/<(?:.|\n)*?>/gm, "")
        : "";
      //var descripcion = "";

      var titulo = this.item.titulo ? this.item.titulo.trim() : "";
      titulo = titulo == "" ? descripcion.substring(0, 20) + "..." : titulo;
      var text =
        `Nota de  Periódico digital \n` +
        this.item.noticiero_nombre +
        `\n` +
        titulo +
        `\n` +
        `Fecha: ` +
        arrFecha[0] +
        `\n` +
        `Hora de inicio: ` +
        hora +
        `\n\n` +
        "Liga" +
        `\n` +
        this.urlShare;

      return text;
    },
  },
  beforeMount() {
    var backData2 = this.$store.state.backData2;
    var d = backData2.length > 0 ? backData2[backData2.length - 1] : {};
    this.from = d.from;
    this.fromParams = d.fromParams;
    this.extraParams = d.extraParams;
    this.load();
  },
  mounted(){
    this.getPermisoNesletter();
  },
  methods: {
    load() {
      //funcion inicial
      //this.isLoading = true;
      this.fuente_info = this.fi;
      if (this.fuente_info != null) {
        this.getNote();
        this.getComments();
      } else {
        this.isLoading = false;
        //redirigir pantalla not found
        this.error("error, url no válida");
      }
    },
    getNote() {
      var post_data = {
        token: this.token,
        key: this.id,
        entrada: this.fuente_info, // TW, I,T,R,Y
        logs:true
      };
      var self = this;
      axios
        .post(this.url + "getNote", post_data)
        .then((response) => {
          self.isLoading = false;
          if (response.data.success) {
            self.setItem(response.data.data);
          } else {
            self.error(response.data.error);
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          self.error(error);
        });
    },
    getComments() {
      //console.log("getComments");
      var post_data = {
        token: this.token,
        key: this.id,
        limit: 5,
        feed: this.fi, // TW, I,T,R,Y
      };
      var self = this;
      if (this.LastEvaluatedKey)
        post_data["LastEvaluatedKey"] = this.LastEvaluatedKey;
      axios.post(this.url + "listComments", post_data).then((response) => {
        if (self.comments.length == 0) {
          self.comments = response.data.result;
          self.total = response.data.total;
        } else {
          self.comments = [].concat(self.comments, response.data.result);
          self.total = self.total + response.data.total;
        }
        self.LastEvaluatedKey = response.data.LastEvaluatedKey
          ? response.data.LastEvaluatedKey
          : null;
      });
    },
    editNote() {
      this.originalItem = Object.assign(this.originalItem, this.item);
      this.editMode = true;
      /*this.isLoading=true;
      this.$router.push({
        name: "notaVideoEdit",
        params: {
          id: this.id,
          fi: this.fi
        }
      });*/
    },
    cancelEdit() {
      this.item = Object.assign(this.item, this.originalItem);
      this.editMode = false;
    },
    async saveEdit() {
      this.isLoading = true;

      var post_data = {
        token: this.token,
        providerID: this.providerID,
        data: {
          cmd: "editNote",
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
          titulo: this.item.titulo,
          descripcion: this.item.descripcion,
        },
      };
      var r = await this.editaNota(post_data);
      console.log(r);
      this.editMode = false;
      this.isLoading = false;
      if (r.success) {
        this.success("Edicion Completa");
      } else {
        this.error(r.error);
      }
    },
    editaNota(post_data) {
      var self = this;
      return new Promise((resolve, reject) => {
        axios
          .post(this.url + "metadatos", post_data)
          .then((response) => {
            resolve(response.data);
          })
          .catch(function (error) {
            resolve({ success: false, error: error });
          });
      });
    },
    async setItem(data) {
      this.item = data;
      var note_params = {
        table: this.getTable(this.item.entrada),
        key: this.item.key,
        token: this.token,
      };
      this.urlShare = await this.getEncryptedUrl(note_params);

      console.log("urlShare");
      console.log(this.urlShare);

      if (this.item.metadatos) {
        var new_item = this.item.metadatos;
        if (new_item.titulo) {
          this.$nextTick(function () {
            this.$set(this.item, "titulo", new_item.titulo);
            this.contentKey = new Date().getTime();
          });
        }

        if (new_item.descripcion) {
          this.$nextTick(function () {
            this.$set(this.item, "descripcion", new_item.descripcion);
            this.contentKey = new Date().getTime();
          });
        }
        this.noStars = new_item.stars ? new_item.stars : this.noStars;

        this.setLikes(new_item.lke);

        this.setStars(this.noStars);
        this.contentKey = new Date().getTime();
      }
    },
    saveNote() {
      this.isLoading = true;
      var p = { from: "notaTextVf", fromParams: { id: this.id, fi: this.fi } };
      this.$store.commit("saveBack2", p);

      this.$router.push({
        name: "guardarEnCarpeta",
        params: {
          keyNote: { id: this.id, fi: this.fi },
        },
      });
    },
    // -----  eliminar nota de carpeta ------
    deleteNote() {
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    elimina() {
      this.showModal = false;
      var folderKey = this.fromParams.id.toString();

      var post_data = {
        token: this.token,
        folderKey: folderKey,
        itemKey: this.extraParams.key,
      };
      var self = this;
      axios
        .post(self.url + "deleteItemFromFolder", JSON.stringify(post_data))
        .then((response) => {
          self.isLoading = false;
          console.log(response.data);
          if (response.data.success) {
            self.$snotify.success(
              "Eliminado Correctamente de Carpeta",
              "Success"
            );
            //var routeBack = self.from == 'folder'
            self.goBack();
          } else {
            self.$snotify.error(response.data.error, "Error");
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          var response = { success: false, error: error };
          console.log(error);
        });
    },
    async saveLike(type) {
      var post_data = {
        token: this.token,
        providerID: this.providerID,
        data: {
          cmd: "editNote",
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
          like: type,
        },
      };
      var r = await this.editaNota(post_data);
      console.log(r);
      if (r.success) {
        this.setLikes(type);

        //this.success('Edicion Completa');
      } else {
        this.error(r.error);
      }
    },
    async saveStars(noStars) {
      var post_data = {
        token: this.token,
        providerID: this.providerID,
        data: {
          cmd: "editNote",
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
          stars: noStars,
        },
      };
      var r = await this.editaNota(post_data);
      console.log(r);
      if (r.success) {
        this.setStars(noStars);
      } else {
        this.error(r.error);
      }
    },
    setStars(noStars) {
      this.noStars = noStars == undefined ? this.noStars : noStars;
      this.pintaStars(noStars);
    },
    pintaStars(noStars) {
      if (noStars != undefined) {
        this.resetStars();
        for (var i = 0; i < noStars; i++) {
          this.stars[i] += " active";
        }
      }
    },
    resetStars() {
      this.stars = [
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
      ];
    },
    rollbackStars() {
      this.pintaStars(this.noStars);
    },
    setLike() {
      this.like = true;
      this.dislike = false;
      this.meh = false;
    },
    setDislike() {
      this.like = false;
      this.dislike = true;
      this.meh = false;
    },
    setMeh() {
      this.like = false;
      this.dislike = false;
      this.meh = true;
    },
    setLikes(type) {
      switch (type) {
        case 0:
          this.setDislike();
          break;
        case 1:
          this.setLike();
          break;
        case 2:
          this.setMeh();
          break;
      }
    },
    getTooltip(i) {
      var tooltip = "";
      switch (i) {
        case 1:
          tooltip = "Irrelevante";
          break;
        case 2:
          tooltip = "Poco Interesante";
          break;
        case 3:
          tooltip = "Relevante";
          break;
        case 4:
          tooltip = "Muy Relevante";
          break;
        default:
          break;
      }
      return tooltip;
    },
    getFecha(fecha) {
      moment.tz.setDefault("America/Mexico_City");
      var tmp = moment(fecha);
      var f = moment
        .tz(tmp, "America/Mexico_City")
        // .utc()
        // .local()
        .format("DD/MM/YYYY HH:mm:ss");
      return f;
    },
    enviar() {
      this.emailModal = true;
    },
    cancelarEnviar() {
      this.emailModal = false;
    },
    async sendEmail(obj) {
      var post_data = {
        token: this.token,
        nota: {
          fi: this.fi,
          key: this.id,
        },
        email: obj.email,
        type: "nota",
      };
      if (obj.subject != "") post_data["subject"] = obj.subject;
      if (obj.type == "correos") {
        if (obj.cc) {
          post_data["cc"] = obj.cc;
        }

        var self = this;

        axios
          .post(this.url + "sendMail", post_data)
          .then((response) => {
            self.emailModal = false;
            if (response.data.success) {
              self.success("Email enviado");
            } else {
              self.error(response.data.error);
            }
          })
          .catch(function (error) {
            self.error(response.data.error);
            console.log(error);
          });
      } else {
        post_data.type = "grupos";
        var r = await this.sendEmails(post_data);
        this.emailModal = false;
        if (r.success) {
          this.success("Email enviado");
        } else {
          this.error(r.error);
        }
      }
    },
    async sendEmails(obj) {
      var post_data = {
        nota: obj.nota,
        token: this.token,
        type: obj.type, //correo o grupos?
        typeObj: "nota",
        items: obj.email, //array de correos o grupos
      };

      if (obj.subject) post_data.subject = obj.subject;
      var self = this;
      return new Promise((resolve) => {
        axios
          .post(self.url + "sendEmails", JSON.stringify(post_data))
          .then(function (response) {
            console.log(response);
            if (response.data.success) resolve({ success: true });
            else resolve({ success: false, error: response.data.error });
          })
          .catch(function (error) {
            resolve({ success: false, error: error });
          });
      });
    },
    // VIDEO PLAYER METHODS
    playerReadied(player) {
      var engine = player.tech_.hls || player.tech_.vhs;
      if (engine && engine.xhr) {
        engine.xhr.beforeRequest = function (options) {
          return options;
        };
      }
    },
    playVideo() {
      this.activeVideo = true;
    },
    goBack() {
      var backData2 = this.$store.state.backData2;
      var data = backData2.pop();
      if (data == undefined) {
        this.$router.push("/main");
      } else {
        var from = data.from;
        var params = data.fromParams;

        this.$router.push({
          name: from,
          params: params,
        });
      }
    },
    goToNotes() {
      moment.tz.setDefault("America/Mexico_City");

      var tmp = moment(this.item.publicado_utc);

      var fecha = moment
        .tz(tmp, "America/Mexico_City")
        // .utc()
        // .local()
        .format("YYYY-MM-DD");
      var fechaC = new Date(this.item.publicado_utc);

      var query = {
        fi: {},
        keywords: [],
        ubicacion: "global",
        dias: "rango",
        fecha: {
          fin: fecha,
        },
        hora: {
          ini: "00:00",
          fin: "23:59",
        },
      };
      var medio = this.item.medio;
      var arr = [];
      arr.push(this.item.key_src);
      query.fi[medio] = arr;
      query.fiParams = {};
      //query.fiParams[medio] = [1,1];

      var p = {
        from: "notaTextVf",
        fromParams: {
          fi: this.fi,
          id: this.id,
        },
        extraParams: {},
      };
      this.$store.commit("saveBack2", p);

      var p2 = {
        channel: this.item.noticiero_nombre,
        defaultImage: this.defaultImage,
        noticiero_imagen: this.item.sourceImg,
        item: this.item,
        fechaC: fechaC,
      };

      this.$store.commit("saveNotasChannel", p2);

      this.$router.push({ name: "notas", params: { query: query } });
    },
    parseFecha(fecha) {
      //fecha= "2020-02-06 16:13:12"
      moment.tz.setDefault("America/Mexico_City");

      var tmp = moment(fecha);

      var f = moment
        .tz(tmp, "America/Mexico_City")
        
        .format("DD/MM/YYYY HH:mm:ss");
      return f;
    },
    //comentarios
    showComentario() {
      this.showComment = true;
    },
    async addComment() {
      var post_data = {
        token: this.token,
        key: this.id,
        feed: this.fi,
        comentario: this.comment,
      };
      var self = this;
      axios
        .post(this.url + "addComment", post_data)
        .then((response) => {
          this.cleanComment();
          if (response.data.success) {
            var new_comment = response.data.data;
            this.comments.unshift(new_comment);
          }
        })
        .catch(function (error) {
          self.error(error);
        });
    },
    cleanComment() {
      this.comment = "";
    },
    eliminaComentario(comment, ndx) {
      this.commentKey = comment;
      this.commentIndex = ndx;
      smsModal: "¿Desea Eliminar éste comentario?", (this.showModal = true);
    },
    cancelar() {
      this.commentKey = null;
      this.commentIndex = null;
      this.showModal = false;
    },
    deleteComment() {
      this.isLoading = true;
      this.showModal = false;
      var post_data = {
        token: this.token,
        key: this.id,
        feed: this.fi,
        commentKey: this.commentKey,
      };
      var self = this;
      axios
        .post(this.url + "deleteComment", post_data)
        .then((response) => {
          self.isLoading = false;
          if (response.data.success) {
            self.success("Comentario Eliminado");
            self.comments.splice(self.commentIndex, 1);
            self.cancelar();
          } else {
            self.error(response.data.error);
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          this.$snotify.error(error, "Error");
        });
    },
    replaceByDefault(e) {
      e.target.src = this.item.sourceImg;
    },
    setTooltip() {
      this.tooltip = true;
    },
    removeTooltip() {
      this.tooltip = false;
    },
    //compartir nota....
    compartir() {
      this.shareAlt = true;
    },
    cancelarShare() {
      this.shareAlt = false;
    },
    async share(opc) {
      this.shareAlt = false;
      var titulo = this.item.titulo;
      var descripcion = this.item.descripcion ? this.item.descripcion : "";
      var w = screen.width / 2;
      var h = screen.height / 2;
      var left = screen.width / 2 - w / 2;
      var top = screen.height / 2 - h / 2;
      var config =
        "menubar=no,location=yes,resizable=yes,scrollbars=no,status=yes, width=" +
        w +
        ",height=" +
        h +
        ",top=" +
        top +
        ",left=" +
        left;
      let popupWindow = null;

      var note_params = {
        table: this.getTable(this.item.entrada),
        key: this.item.key,
        token: this.token,
      };

      var urlShare = await this.getEncryptedUrl(note_params);
      console.log(urlShare,"2");
      switch (opc) {
        case "E": //email
          this.enviar();
          break;
        case "TW": //twitter
          var url = "https://twitter.com/intent/tweet/";
          var params = "?text=" + encodeURIComponent(titulo);
          params += "&url=" + encodeURIComponent(urlShare);
          popupWindow = window.open(url + params, "sharer", config);
          break;
        case "FB":
          var url = "https://www.facebook.com/sharer/sharer.php";
          var params = "?title=" + encodeURIComponent(titulo);
          params += "&u=" + encodeURIComponent(urlShare);
          params += "&description=" + encodeURIComponent(descripcion);
          popupWindow = window.open(url + params, "sharer", config);
          break;
        case "W":
          var url = "https://api.whatsapp.com/send";
          var contenido = this.getContent;
          var allContent = encodeURIComponent(contenido);
          var params = "?text=" + allContent;
          popupWindow = window.open(url + params, "sharer", config);
          break;
        default:
          break;
      }
    },
    getTable(fi) {
      var table = "";
      switch (fi) {
        case "T":
        case "R":
          table = "t_notas";
          break;
        case "FB":
          table = "t_facebook";
          break;
        case "Y":
          table = "t_youtube";
          break;
        case "I":
          table = "t_instagram";
          break;
        case "TW":
          table = "t_twitter";
          break;
        case "PD":
          table = "t_rss";
          break;
      }
      return table;
    },
    async getEncryptedUrl(post_data) {
      console.log("getEncryptedUrl");
      var self = this;
      return new Promise((resolve) => {
        axios
          .post(self.url + "getEncryptedUrl", post_data)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch(function (error) {
            self.error(error);
          });
      });
    },
    async redo() {
      //reestablcer nota a datos originales (quitar metadatos)
      this.isLoading = true;
      this.item.metadatos = {};

      var post_data = {
        token: this.token,
        providerID: this.providerID,
        data: {
          cmd: "removeMetadata",
          token: this.token,
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
        },
      };
      var r = await this.editaNota(post_data);
      console.log(r);
      this.isLoading = false;
      if (r.success) {
        this.reload();
        this.success("Edición Completa");
      } else {
        this.error(r.error);
      }
    },
    reload() {
      this.item = {};
      this.comments = [];
      this.load();
    },
    error(msg) {
      this.$snotify.error(msg, this.$store.state.error);
    },
    success(msg) {
      this.$snotify.success(msg, this.$store.state.success);
    },
    // --------- copy to cliipboard ----------
    copy() {
      this.$refs.copyText.select();
      document.execCommand("copy");
      this.success("Copiado al portapapeles");
    },
    menuVisible(menu) {
      this.menuOn = menu;
    },
    getFechaSeparada(fecha) {
      var f = this.parseFecha(fecha);
      var fechar_arr = f.split(" ");
      return {
        fecha: fechar_arr[0],
        hora: fechar_arr[1],
      };
    },
    async agregar_note_newsletter() {
      var table = this.getTable(this.item.entrada);
      var p = { from: "notaTextVf", fromParams: { id: this.id, fi: this.fi } };
      this.$store.commit("saveBack2", p);
      
      this.$router.push({name:'agregarNotaNewsletter',params:{keyNote:this.item.key,table:table}});  
      var table = this.getTable(this.item.entrada);
     
    },

    async agregarItemnewsletter2() {
      this.isLoading = true;
      var table = this.getTable(this.item.entrada);
      var formQuery = {
        key: this.$store.state.userInfo.id,
        nota_id: this.item.key,
        table_nota: table,
      };
      await axios
        .post(
          this.url + "add_item_newsletter",
          formQuery
        ).then((response) => {
          if (response.data.success) {
            this.success(`Agregado correctamente a Newsletter`);
            // setTimeout(() => {
            //   this.goBack();
            // }, "1500");
          } else {
            this.error(response.data.body);
          }

        })
        .catch(function (error) {
          console.log(error);
          this.error("Intente nuevamente");
        });
      this.isLoading = false;
    },



    async getPermisoNesletter(){
      var post_data = {
        id:this.$store.state.userInfo.id,
      }

      await axios
        .post(
          this.url + "permisonewsletter",
          post_data
        ) //petición
        .then((response) => {
          this.permissionsNewsletter = response.data;
        })
        .catch(function (error) {
          
        });
    }
  },
  props: ["fi", "id"],
};
</script>


<style scoped>
.escondido {
  position: absolute;
  left: -1000px;
  top: -1000px;
}

.sub {
  color: #00b99e !important;
}
.post-image {
  max-width: 350px;
  width: 100%;
  height: auto;
  vertical-align: center;
}
.specialPadding {
  padding: 8px 15px;
}

.chip.iconed {
  padding-right: 20px !important;
}

.back-button {
  padding: 0;
  width: 27px;
  height: 27px;
  border-radius: 5px;
}

.back-button:hover svg {
  fill: #fff;
}
</style>

